import AccordionTimeline from './AccordionTimeline';

export default AccordionTimeline;
